<script setup>
import Footer from '@/components/Footer.vue' 
import Header from '@/components/Header.vue'
const props = defineProps({
  isArticle: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div :class="{'bg-gray-100 p-4' : !isArticle}">
    <Header :isArticle="isArticle" />
    <slot />
    <Footer />
  </div>
</template>
